// extracted by mini-css-extract-plugin
module.exports = {"gray-text":"price_gray-text__82E2R","fbt-Mobile-price":"price_fbt-Mobile-price__3B6Fz"};